export default __webpack_public_path__ + "static/media/mobileApp.bbac6e25.jpg";